import { useState, useEffect } from 'react';
import TopBar from './components/TopBar';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import AdvantagesSection from './components/AdvantagesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ChatPopup from './components/ChatPopup';

const HomePage = () => {
  const [showChatPopup, setShowChatPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowChatPopup(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      <HeroSection />
      <BenefitsSection />
      <AboutSection />
      <ServicesSection />
      <AdvantagesSection />
      <TestimonialsSection />
      <ContactSection />
      <FAQSection />
      <Footer />
      <FloatingWhatsApp />
      {showChatPopup && <ChatPopup onClose={() => setShowChatPopup(false)} />}
    </div>
  );
};

export default HomePage;
